/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EUserStatusRequest = 'Activated' | 'Deactivated' | 'All';

export const EUserStatusRequest = {
    Activated: 'Activated' as EUserStatusRequest,
    Deactivated: 'Deactivated' as EUserStatusRequest,
    All: 'All' as EUserStatusRequest
};

